export const tinymce = {
    config: {
        highlight_on_focus: false,
        branding: false,
        toolbar: false,
        menubar: false,
        elementpath: false,
        paste_as_text: false,
        paste_webkit_styles: 'color font-size font-family text-align font-weight text-decoration border',
        resize: false,
        statusbar: false,
        content_style: `
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100..900&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        body{
            background-color:#eeeeee;
            font-family:-apple-system, BlinkMacSystemFont,"Verdana", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
        }
        `,
        font_family_formats: `
            Arial=arial,helvetica,sans-serif;
            Arial Black=arial black,avant garde;
            Book Antiqua=book antiqua,palatino;
            Comic Sans MS=comic sans ms,sans-serif;
            Courier New=courier new,courier;
            Fira Sans=fira sans;
            Georgia=georgia,palatino;
            Helvetica=helvetica;
            Impact=impact,chicago;
            Lato="Lato", sans-serif;
            Montserrat="Montserrat", sans-serif;
            Open Sans=open sans,sans-serif;
            Roboto="Roboto",sans-serif;
            Symbol=symbol;
            Tahoma=tahoma,arial,helvetica,sans-serif;
            Terminal=terminal,monaco;
            Times New Roman=times new roman,times;
            Trebuchet MS=trebuchet ms,geneva;
            Verdana=verdana,geneva;
            Webdings=webdings;
            Wingdings=wingdings,zapf dingbats`,
        setup: editor => {
            editor.on('init', () => {
                editor.execCommand('fontName', false, 'Verdana');
            });
        }
    }
};
